/**
 * formats with a hyphen every 4 characters
 * eg: "KFI2XAXBFDW2" -> "KFI2-XAXB-FDW2"
 */
export const formatLoyaltyCardId = (cardId: string) => cardId.replace(/(.{4})(?=.)/g, '$1-');

export const cleanLoyaltyCardId = (loyaltyCardId: string) =>
  loyaltyCardId.replace(/[^a-zA-Z0-9]/g, ''); // remove all non alpha numeric characters
